import { EntityType } from '@frontend/common';
import { IdentificationClient } from '@frontend/identification/api';
import { Identification, UpdateIdentification } from '@frontend/identification/types';
import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import UpdateModal from '../../../../modal/update-modal/update-modal.component';

export interface BadgeUpdateProps {
    badge: Identification;
    onSubmitSuccess?: (value: Identification) => void;
}

export const BadgeUpdate = (props: BadgeUpdateProps) => {
    return (
        <UpdateModal<Identification, UpdateIdentification>
            order={['key']}
            object={props.badge}
            values={{ ...props.badge }}
            keyOverwrite={new Map([['key', CommonMessage.OBJECTS.BADGE.DEFAULT]])}
            onSubmit={(value) => IdentificationClient.patchIdentification(props.badge.account_id, props.badge.id, value)}
            type={EntityType.IDENTIFICATION}
            label={
                <FormattedMessage
                    id='badge.update.title'
                    defaultMessage='Update Badge'
                />
            }
            onSubmitSuccess={props.onSubmitSuccess}
            successMessageOverwrite={
                <FormattedMessage
                    id='badge.update.success'
                    defaultMessage='Badge updated successfully'
                />
            }
        />
    );
};
